import { render, staticRenderFns } from "./CloneAnamneseModal.vue?vue&type=template&id=21a3c85c"
import script from "./CloneAnamneseModal.vue?vue&type=script&lang=js"
export * from "./CloneAnamneseModal.vue?vue&type=script&lang=js"
import style0 from "./CloneAnamneseModal.vue?vue&type=style&index=0&id=21a3c85c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports